import React from 'react';
import { Grid, Box, Typography, Switch } from '@mui/material';

interface TextWithToggleProps {
  toggleName?: string;
  isChecked?: boolean;
  handleToggleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  labelSx?: any;
}
const TextWithToggle: React.FC<TextWithToggleProps> = ({ toggleName, isChecked, handleToggleChange, name, labelSx }) => {
  const label = { inputProps: { 'aria-label': 'Switch demo' } };
  return (
    <>
      <Box>
        <Grid container sx={{ background: '#fff', borderRadius: '6px', height: '38px', border: '0.38px solid #B2B3B7' }}>
          <Grid
            item
            md={8}
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography sx={{ fontSize: '12px', ...labelSx }}>{toggleName}</Typography>
          </Grid>
          <Grid
            item
            md={4}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'end',
            }}
          >
            <Switch
              checked={isChecked}
              onChange={handleToggleChange}
              name={name}
              size="small"
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: '#2C60AA',
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: '#2C60AA',
                },
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default TextWithToggle;
